import { Page } from "../styled"
import { SchemeEditorStoreProvider } from "./store"
import BlockSystem from "./components/block-system"
import MenuBlocks from "./components/menu-blocks"
import Loader from "./components/loader"

type Props = {
  params?: { schemeId?: string }
}

const SchemeEditor = ({ params }: Props) => {

  return (
    <SchemeEditorStoreProvider>
      <Loader schemeId={params?.schemeId || null} />
      <Page>
        <BlockSystem/>
        <MenuBlocks/>
      </Page>
    </SchemeEditorStoreProvider>
  )

}

export default SchemeEditor